/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.filter('versionDisplay', () => (function(version) {
    const version_num = version.toString();
    if (3 > version_num.length) { return Array((3 - version_num.length) + 1).join('0') + version_num; } else { return version_num; }
}));
